// extracted by mini-css-extract-plugin
module.exports = {"license":"style-module--license--1S7zw","bottomWrapper":"style-module--bottom-wrapper--1sVyw","info":"style-module--info--1w_DL","contactUs":"style-module--contact-us--xalRv"};